import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Form, Input, Label, Button, Icon, Message } from 'semantic-ui-react';
import i18next from 'i18next';

import API from '../../../../../../actions/api';
import AreaAdditionForm from '../../area-addition-form/AreaAdditionForm';

import './ExternalLoadPane.scss';

class ExternalLoadPane extends Component {
    defaultState = {
        externalAreaNameToImport: '',
        isExternalAreaExising: false,
        deliveryZones: null,
        externalLoadingStatus: {
            loading: false,
            message: '',
            error: ''
        }
    };
    state = { ...this.defaultState };

    constructor(props) {
        super(props);

        this.resetExternalLoading = this.resetExternalLoading.bind(this);
        this.handleAreaNameChange = this.handleAreaNameChange.bind(this);
        this.handleExternalAreaLoading = this.handleExternalAreaLoading.bind(this);
        this.isEligbleForSubmition = this.isEligbleForSubmition.bind(this);
    }

    resetExternalLoading(override) {
        const { externalAreaNameToImport, ...rest } = this.defaultState;
        this.setState({ ...rest, ...override });
    }

    handleAreaNameChange(event, { value }) {
        this.setState({ externalAreaNameToImport: value });
    }

    isEligbleForSubmition() {
        return this.state.isExternalAreaExising;
    }

    calculateAreaPaths(data) {
        const areaPaths = [];
        const geoJSON = data.geojson;
        let polygonBoundaries;

        if (geoJSON.type === "Polygon") {
            polygonBoundaries = geoJSON.coordinates[0];
        } else if (geoJSON.type === "MultiPolygon") {
            polygonBoundaries = geoJSON.coordinates[1][0];
        } else {
            throw new Error('Unrecoginezed data received when tried loading an external areas');
        }

        // For some reason this is the only way to get the right location for you polygon (otherwise it lands near greece)
        polygonBoundaries.forEach((location, index) => {
            if (index % 10 === 0) areaPaths.push({ lat: location[1], lng: location[0] });
        });

        return areaPaths;
    }

    handleExternalAreaLoading(event) {
        this.props.clearDrawnDeliveryZonesFromMap();
        this.resetExternalLoading({ externalLoadingStatus: { ...this.state.externalLoadingStatus, ...{ loading: true } } });

        API.deliveryAreasPool.external(this.state.externalAreaNameToImport)
            .then(({ data }) => {
                if (data.length === 0) {
                    this.setState({
                        externalLoadingStatus: {
                            ...this.state.externalLoadingStatus, ...{
                                error: '',
                                message: i18next.t('deliveryAreasNotFound'),
                                loading: false
                            }
                        }
                    });
                } else {
                    const areaPaths = this.calculateAreaPaths(data[0]);
                    if (areaPaths.length > 0) {
                        this.setState({
                            isExternalAreaExising: true,
                            deliveryZones: [{ boundaries: areaPaths }],
                            externalLoadingStatus: { error: '', message: '', loading: false }
                        });
                        this.props.drawDeliveryZonesOnMap(areaPaths, '#40E0D0');
                    }
                }
            }).catch(err => {
                this.setState({
                    externalLoadingStatus: {
                        ...this.state.externalLoadingStatus, ...{
                            error: err.toString(),
                            message: '',
                            loading: false
                        }
                    }
                });
            });
    }

    render() {
        const { addNewDeliveryAreas } = this.props;

        return (
            <Grid padded>
                <Grid.Row>
                    <Grid.Column width={13}>
                        <Input
                            action={<Button primary content={i18next.t('load')} onClick={this.handleExternalAreaLoading} />}
                            icon='search'
                            iconPosition='left'
                            placeholder={i18next.t('areaName')}
                            loading={this.state.externalLoadingStatus.loading}
                            value={this.state.externalAreaNameToImport}
                            onChange={this.handleAreaNameChange}
                        />
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <Label color='teal' size='large'
                            as='a' target='_blank'
                            href='https://nominatim.openstreetmap.org/search.php?q=Tel+Aviv&polygon_geojson=1&viewbox='
                            className='pi-deliveries-list-external-lookup'>
                            <Icon name='map' />
                            {i18next.t('regionLookup')}
                        </Label>
                    </Grid.Column>
                </Grid.Row>
                {this.state.isExternalAreaExising &&
                    <Grid.Row>
                        <Grid.Column>
                            <AreaAdditionForm
                                addNewDeliveryAreas={addNewDeliveryAreas}
                                isEligbleForSubmition={this.isEligbleForSubmition}
                                deliveryZones={this.state.deliveryZones}
                                addToPool={true}
                               
                            />
                        </Grid.Column>
                    </Grid.Row>
                }
                {this.state.externalLoadingStatus.message &&
                    <Grid.Row>
                        <Grid.Column>
                            <Message icon>
                                <Icon name='circle warning' />
                                <Message.Content>{this.state.externalLoadingStatus.message}</Message.Content>
                            </Message>
                        </Grid.Column>
                    </Grid.Row>
                }
                {this.state.externalLoadingStatus.error &&
                    <Grid.Row>
                        <Grid.Column>
                            <Message negative
                                icon='cancel'
                                header={i18next.t("externalLoadingFailed")}
                                content={this.state.externalLoadingStatus.error} />
                        </Grid.Column>
                    </Grid.Row>
                }
            </Grid>
        );
    }
}

ExternalLoadPane.propTypes = {
    addNewDeliveryAreas: PropTypes.func,
    drawDeliveryZonesOnMap: PropTypes.func,
    clearDrawnDeliveryZonesFromMap: PropTypes.func,
    
};

export default ExternalLoadPane;
